import { useContext } from "react";
import { LoggedInUserContext } from "../context/loggedInUserContext";
import { removeItem } from "../utils/localStorage";
import { useNavigate } from "react-router-dom";
import { Roles } from "../types/role.enums";
const Header = ({ user }: { user: any }) => {
  const navigate = useNavigate();
  const { loggedInUserContext, setLoggedInUserContext } =
    useContext(LoggedInUserContext);
  const handleLogout = () => {
    setLoggedInUserContext(null);
    removeItem("user");
    navigate("/");
  };
  return (
    <div className="flex justify-between items-center mt-5">
      <div></div>
      <h1
        className="text-xl cursor-pointer"
        onClick={() => {
          if (loggedInUserContext?.role_name === Roles.SUPER_ADMIN)
            navigate("/admin");
          else navigate("/");
        }}
      >
        The Auction Finder
      </h1>
      <div className="flex items-center justify-between gap-2 m-1">
        {user ? (
          <>
            <button
              onClick={handleLogout}
              className="border-2 px-1 border-gray-600 bg-gray-400"
            >
              Logout
            </button>
            {loggedInUserContext?.role?.name === Roles.SUPER_ADMIN ? null : (
              <button
                onClick={() => navigate("/account")}
                className="border-2 px-1 border-gray-600 bg-gray-400"
              >
                Account
              </button>
            )}
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Header;
